import axios from 'services/axios';
import { RoutePaths } from '../routes/history';
import { setStorage } from './Browser';
import { PartnerId } from './Integration';

const TRIMBLE_LEAF_HELPER_BASE_URL = import.meta.env.VITE_APP_TRIMBLE_LEAF_HELPER_BASE_URL || '';
const TRIMBLE_THIRD_PARTY_ACCESS_BASE_URL =
  import.meta.env.VITE_APP_TRIMBLE_THIRD_PARTY_ACCESS_BASE_URL || '';
const BASE_API_URL = import.meta.env.VITE_APP_API_URL;
const TRIMBLE_APP_NAME = import.meta.env.VITE_APP_TRIMBLE_APP_NAME || '';
const BASE_URL = window.origin;
const REDIRECT_URI = `${BASE_URL}${RoutePaths.CallbackView(PartnerId.Trimble2).toString()}`;
const clientId = import.meta.env.VITE_APP_TRIMBLE_CLIENT_ID || '';

export const redirectToAuthentication = async () => {
  try {
    const response: any = await axios.post(`${TRIMBLE_LEAF_HELPER_BASE_URL}/get_url`, {
      application_name: TRIMBLE_APP_NAME,
      client_id: clientId,
      client_redirect_url: REDIRECT_URI,
    });
    if (response) {
      setStorage('trimble_connect_redirect', true);
      const url = response.data.url;
      window.location.replace(url);
    }
  } catch (error: any) {
    console.error('failed to pass to Trimble', error.message);
    return error;
  }
};

export const redirectToGrantOrgs = async () => {
  window.location.replace(
    `${TRIMBLE_THIRD_PARTY_ACCESS_BASE_URL}?clientid=${clientId}&redirectionUrl=${REDIRECT_URI}`,
  );
};

export const getTokenAndRefreshToken = async (code: string, user_id: string, org_id: string) => {
  try {
    const response: any = await axios.post(`${BASE_API_URL}/valet/v2/trimble_auth_code`, {
      user_id: user_id,
      org_id: org_id,
      redirect_uri: REDIRECT_URI,
      code: code,
    });
    if (response) {
      const authConfig: any = response.data.auth_config;
      setStorage('trimble_access_token', authConfig.access_token);
      setStorage('trimble_refresh_token', authConfig.refresh_token);

      return response;
    }
  } catch (error: any) {
    console.error('failed to pass to Trimble', error.message);
    return error;
  }
};

export const getOrgs = async (accessToken: string) => {
  const organizations = await getTrimbleOrganizations(accessToken);
  return organizations;
};

export const getTrimbleOrganizations = async (accessToken: string) => {
  try {
    const response: any = await axios.get(
      `${BASE_API_URL}/valet/v2/trimble_orgs?trimble_token=${accessToken}`,
    );

    return response?.data?.organizations;
  } catch (err: any) {
    console.error('GET Trimble Organizations:', err);
    return err;
  }
};
